import React, { FC } from 'react'
import StylesModule from 'components/lv1/movie.module.scss'

export interface movieProps {
  title: string
}

const Movie: FC<movieProps> = ({ title }) => {
  return (
    <section className={StylesModule.movie}>
      <div className={StylesModule.movie__wrap}>
        <iframe
          className={StylesModule.movie__iframe}
          src="https://www.youtube.com/embed/MViKSkfswmg"
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title={title}
        ></iframe>
      </div>
    </section>
  )
}

export default Movie
